import geolocationErrorDesktop from 'assets/geolocation-error-desktop.png';
import geolocationErrorMobile from 'assets/geolocation-error-mobile.png';
import notFoundErrorDesktop from 'assets/not-found-error-desktop.png';
import notFoundErrorMobile from 'assets/not-found-error-mobile.png';
import systemErrorDesktop from 'assets/system-error-desktop.png';
import systemErrorMobile from 'assets/system-error-mobile.png';

import { ErrorHandlerType } from './types';

export interface ErrorData {
  title: string;
  description: string;
  image: any;
  buttonTxt?: string;
}

export function getErrorData(
  type: ErrorHandlerType | undefined,
  isMobile: boolean,
  _isTv = false
): ErrorData {
  const img = (mobile: any, desktop: any) => (isMobile ? mobile : desktop);

  /** PERDA DE SINAL — mesmo copy do documento BANDPLAY (web/TV). */
  const noInternet: ErrorData = {
    title: 'Não\nencontramos sua conexão com a internet',
    description:
      'Por favor, verifique se o Wi-Fi ou os dados móveis estão funcionando',
    image: img(systemErrorMobile, systemErrorDesktop),
  };

  const map: Record<ErrorHandlerType, ErrorData> = {
    [ErrorHandlerType.NO_INTERNET]: noInternet,
    [ErrorHandlerType.NETWORK_ERROR]: {
      title: 'Algo deu errado na sua conexão',
      description: 'Recarregue a página para continuar.',
      image: img(systemErrorMobile, systemErrorDesktop),
      buttonTxt: 'Recarregar a página',
    },
    [ErrorHandlerType.NOT_FOUND]: {
      title: 'Parece que este item já não está mais por aqui.',
      description: 'Que tal dar uma olhadinha em outras opções?',
      image: img(notFoundErrorMobile, notFoundErrorDesktop),
      buttonTxt: 'Voltar para página inicial',
    },
    [ErrorHandlerType.GEOLOCATION_ERROR]: {
      title: 'Este conteúdo não está acessível na sua região',
      description:
        'Mas não se preocupe: temos várias outras opções esperando por você. Bora explorar?',
      image: img(geolocationErrorMobile, geolocationErrorDesktop),
      buttonTxt: 'Voltar para página inicial',
    },
  };

  return (
    (type && map[type]) ?? {
      title: 'Alguma coisa não saiu como esperado',
      description:
        'Tente recarregar a página ou reiniciar o app para continuar.',
      image: img(systemErrorMobile, systemErrorDesktop),
      buttonTxt: 'Voltar para página inicial',
    }
  );
}